export default function Separator() {
  return (
    <div style={{ width: '100%', height: '1px', background: '#3F3F40' }} />
  )
}